var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7214 0.711548H9.19166C6.05318 0.711548 3.36304 3.21773 3.36304 6.3136V21.793L0.374008 26.9527H14.7214C17.8599 26.9527 20.55 24.4466 20.55 21.2033V6.46102C20.55 3.21773 18.0093 0.711548 14.7214 0.711548ZM18.3082 21.3507C18.3082 23.2672 16.6643 24.7414 14.8708 24.7414H5.75427V6.46102C5.75427 4.54453 7.39824 3.07031 9.19166 3.07031H14.7214C16.6643 3.07031 18.1588 4.69195 18.1588 6.46102V21.3507H18.3082Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6181 8.37744H8.44441V10.5888H15.6181V8.37744Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6181 12.3579H8.44441V14.5692H15.6181V12.3579Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6181 16.3383H8.44441V18.5496H15.6181V16.3383Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedChat);
export default __webpack_public_path__ + "static/media/selected-chat.cfde1d13bd12281ab4900b968be3ec6e.svg";
export { ForwardRef as ReactComponent };